exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__navLink___m65DD{text-transform:capitalize}.style__navLink___m65DD:hover{background:#e2e2e2}.style__activeNavLink___RnDpE{color:#fff!important;background:#2199e8;text-transform:capitalize}", "", {"version":3,"sources":["/./containers/curateLit/style.css"],"names":[],"mappings":"AAAA,wBACC,yBAA2B,CAC3B,AAED,8BACC,kBAAoB,CACpB,AAED,8BACC,qBAAwB,AACxB,mBAAoB,AACpB,yBAA2B,CAC3B","file":"style.css","sourcesContent":[".navLink {\n\ttext-transform: capitalize;\n}\n\n.navLink:hover {\n\tbackground: #e2e2e2;\t\n}\n\n.activeNavLink {\n\tcolor: white !important;\n\tbackground: #2199e8;\n\ttext-transform: capitalize;\n}\n\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"navLink": "style__navLink___m65DD",
	"activeNavLink": "style__activeNavLink___RnDpE"
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!/data/www/SGDBackend-Nex2/~/postcss-loader!./containers/curateLit/style.css
// module id = 555
// module chunks = 0